import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import AdminHeader from '../../components/admin/AdminHeader';
import ChangePasswordForm from '../../components/admin/ChangePasswordForm';
import { logError } from '../../utils/apiError';
import authService from '../../services/authService';

const ChangePasswordPage = () => {
  const [adminUser, setAdminUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is logged in as admin using authService
    if (!authService.isAdminLoggedIn()) {
      console.log('ChangePasswordPage - Not authenticated, redirecting to login');
      navigate('/admin/login');
      return;
    }
    
    // Get admin user data from authService
    const userData = authService.getAdminUser();
    
    if (!userData) {
      console.log('ChangePasswordPage - No admin user data, redirecting to login');
      navigate('/admin/login');
      return;
    }
    
    console.log('ChangePasswordPage - User data:', userData);
    setAdminUser(userData);
  }, [navigate]);

  const handlePasswordChangeSuccess = () => {
    console.log('Password changed successfully');
    
    // Explicitly prevent navigation
    if (window) {
      // This prevents history changes
      window.history.pushState({}, '', window.location.pathname);
      console.log('ChangePasswordPage - Pushed history state to stay on current page:', window.location.pathname);
    }
    
    // Stay on current page and scroll to show success message
    setTimeout(() => {
      window.scrollTo(0, 0);  // Scroll to top to show success message
      
      // Double-check we're still on the change password page
      if (window.location.pathname !== '/admin/change-password') {
        console.log('ChangePasswordPage - Detected incorrect path, redirecting back to change password page');
        navigate('/admin/change-password');
      } else {
        console.log('ChangePasswordPage - Successfully stayed on change password page');
      }
    }, 100);
  };

  if (!adminUser) return <div>Loading...</div>;

  return (
    <div>
      <AdminHeader adminUser={adminUser} />
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '20px' 
      }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}>
          <div>
            <h2 style={{ 
              margin: '0 0 8px 0', 
              fontSize: '28px', 
              color: '#111827' 
            }}>
              Security Settings
            </h2>
            <p style={{ 
              margin: '0', 
              fontSize: '14px', 
              color: '#6b7280' 
            }}>
              Update your password to keep your account secure
            </p>
          </div>
          <div style={{ marginLeft: 'auto' }}>
            <Link to="/admin/account" style={{
              padding: '8px 16px',
              backgroundColor: '#f3f4f6',
              color: '#4b5563',
              borderRadius: '6px',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500',
              border: '1px solid #e5e7eb'
            }}>
              ← Back to Account
            </Link>
          </div>
        </div>
      
        <div style={{ 
          display: 'flex',
          justifyContent: 'center'
        }}>
          <ChangePasswordForm onSuccess={handlePasswordChangeSuccess} />
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
